import React from 'react';
import { Modal, Form, Input, message } from 'antd';

const AddTaskModal = ({ visible, onAdd, onCancel, confirmLoading = false }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        try {
          // 添加默认值并确保所有字段都有有效值
          const formattedValues = {
            jobNumber: values.jobNumber.trim(),  // 移除多余空格
            customer: values.customer.trim(),    // 移除多余空格
            material: "-",
            materialQuantity: "-",
            materialStatus: "-",
            machine: "-",
            jobStatus: "yellow" // 默认为等待状态
          };
          
          // 验证工作号和客户名称不能为空
          if (!formattedValues.jobNumber || !formattedValues.customer) {
            message.error('Job number and customer name cannot be empty');
            return;
          }
          
          onAdd(formattedValues);
        } catch (error) {
          console.error('Error adding task:', error);
          message.error('An error occurred while adding the task');
        }
      })
      .catch(info => {
        console.error('Validation failed:', info);
        message.error('Please check your input');
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Add New Task"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Add"
      cancelText="Cancel"
      destroyOnClose={true}
      confirmLoading={confirmLoading}
    >
      <Form
        form={form}
        layout="vertical"
        name="add_task_form"
        preserve={false}
      >
        <Form.Item
          name="jobNumber"
          label="Job Number"
          rules={[{ required: true, message: 'Please input the job number' }]}
        >
          <Input placeholder="Enter job number" />
        </Form.Item>

        <Form.Item
          name="customer"
          label="Customer"
          rules={[{ required: true, message: 'Please input the customer name' }]}
        >
          <Input placeholder="Enter customer name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddTaskModal;